/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocationGrid extends _Ext.GridBase<StockAllocationRow, any> {
        protected getColumnsKey() { return 'Inventory.StockAllocation'; }
        protected getDialogType() { return StockAllocationDialog; }
        protected getIdProperty() { return StockAllocationRow.idProperty; }
        protected getInsertPermission() { return StockAllocationRow.insertPermission; }
        protected getLocalTextPrefix() { return StockAllocationRow.localTextPrefix; }
        protected getService() { return StockAllocationService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        
        rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate","Date");
        }

        protected addButtonClick() {
            
            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(79);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[79].AutoPosting;
            this.editItem(<StockAllocationRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 79,
                TransDate: now.toDateString(),
                RoundOff: 0,
                EmployeeId: userDefinition.UserId,
                AdditionalCharges: 0,
                AutoPosting: autoposting,
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            addbutton.hotkey = 'alt+n';
            addbutton.hint = 'alt+n';
            return buttons;
        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }




    }
}